/*
	Компонент, що показує, скільки часу минуло з моменту `fetched_at` з кешу dashboard-data (React Query).
*/
import { useEffect, useMemo, useState } from "react";
import { useDashboardData } from "../../../../service/dashboard-data.service";
import type { DashboardData } from "../../../../../../shared/types/dashboard-data.type";

function pickFetchedAtSeconds(
	data: DashboardData | null | undefined,
): number | null {
	if (!data) return null;
	const raw =
		data.ad_accounts?.fetched_at ??
		data.mcc_account?.fetched_at ??
		data.apps_info?.fetched_at ??
		data.campaigns_info?.fetched_at;
	return typeof raw === "number" && Number.isFinite(raw) ? raw : null;
}

export const UpdateTime = () => {
	const { data: dashboardData } = useDashboardData();

	const baselineMs = useMemo(() => {
		const seconds = pickFetchedAtSeconds(dashboardData);
		if (seconds == null) return null;
		return seconds * 1000;
	}, [dashboardData]);

	const [secondsAgo, setSecondsAgo] = useState(() =>
		baselineMs != null
			? Math.max(0, Math.floor((Date.now() - baselineMs) / 1000))
			: 0,
	);

	useEffect(() => {
		if (baselineMs == null) return;

		const tick = () => {
			const diff = Math.max(0, Math.floor((Date.now() - baselineMs) / 1000));
			setSecondsAgo(diff);
		};

		tick();
		const id = window.setInterval(tick, 1000);
		return () => window.clearInterval(id);
	}, [baselineMs]);

	const minutes = Math.floor(secondsAgo / 60);

	if (baselineMs == null) {
		return (
			<div className='header-left__info-reload'>
				<div>Оновлено:</div>
				<div>—</div>
			</div>
		);
	}

	return (
		<div className='header-left__info-reload'>
			<div>Оновлено:</div>
			<div>
				{minutes < 1 ? `${secondsAgo} сек ` : `${minutes} хв `}
				тому
			</div>
		</div>
	);
};
